import { Component, Element } from '@stencil/core';

@Component({
  tag: 'uvex-form-field-url',
})
export class FormFieldUrl {
  @Element() el!: HTMLElement;

  componentDidLoad() {
    const input = this.el.querySelector('input') as HTMLInputElement;
    input.value = window.location.href.replace(/#.+$/, '');
  }
}
